<template>
  <div>
    <div :class="$style.label">
      <div
        v-if="totalTaskAmount"
        :class="$style.counter"
      >
        <div :class="$style.step">
          {{ `${finishedTaskAmount}/${totalTaskAmount}` }}
        </div>
        <svg
          :class="$style.svg"
          width="100"
          height="100"
          viewBox="0 0 100 100"
        >
          <circle
            :class="$style.background"
            cx="50"
            cy="50"
            r="45"
            stroke-width="6"
          />
          <circle
            :class="$style.progress"
            cx="50"
            cy="50"
            r="45"
            stroke="white"
            stroke-width="10"
            :stroke-dasharray="dashArray"
            :stroke-dashoffset="dashOffset"
          />
        </svg>
      </div>
      <div
        v-else
        :class="$style.iconContainer"
      >
        <BaseIcon
          name="info"
          color="inverted"
        />
      </div>
      <BaseIcon
        v-if="$screen !== 's'"
        name="chevron-right"
        color="inverted"
      />
    </div>
  </div>
</template>

<script
  setup
  lang="ts"
>
const props = defineProps<{
  finishedTaskAmount: number;
  totalTaskAmount: number;
}>();

const percentage = computed(
  () => (props.finishedTaskAmount / props.totalTaskAmount) * 100,
);
const dashArray = computed(() => Math.round(Math.PI * 90));
const dashOffset = computed(
  () => dashArray.value * (1 - percentage.value / 100),
);
</script>

<style
  module
  lang="scss"
>
.label {
  display: flex;
  align-items: center;
  background-color: var(--color-primary);
  height: 32px;
  border-radius: 32px;
  color: var(--color-text-inverted);
  font-size: 12px;
  font-weight: bold;
  padding: 3px;
  cursor: pointer;
  user-select: none;
  animation: glow-breathe 2.2s ease-in-out infinite;
}

@keyframes glow-breathe {
  0%, 100% {
    box-shadow:
      0 2px 10px rgba(76, 73, 197, 0.25),
      0 0 0 0px rgba(76, 73, 197, 0);
  }
  50% {
    box-shadow:
      0 4px 28px rgba(76, 73, 197, 0.50),
      0 0 0 5px rgba(76, 73, 197, 0.12);
  }
}

.counter {
  position: relative;
}

.iconContainer {
  display: flex;
  align-items: center;
}

.step {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
}

.circle {
  fill: none;
  transform: rotate(-90deg);
}

.svg {
  display: flex;
  width: 26px;
  height: 26px;
  transform: rotate(-90deg);
  fill: none;
}

.background {
  stroke: rgba(255,255,255,0.2);
}

.progress {
  stroke-linecap: round;

  .base:not(.customerColor) & {
    stroke: var(--color-primary);
  }
}
</style>
